import { Injectable } from '@angular/core';

import { WrapperVersion } from '../../shared/models/wrapper-version.model';
import { ConfigParserService } from '../../shared/services/config-parser.service';

// TODO: Refactor edge to be shared by both
export interface PwaConfig {
    bridgeTimeoutInSeconds: number;
    diagnosticsTimeoutInSeconds: number;
    enablePwaIdleCallback: boolean;
    installedAppsToLookFor: string;
    mock?: PwaMockConfig;
    oobToWeb: boolean;
    pwaJumpListEnabled: boolean;
    PwaStartPageEnabled: boolean;
    resourceUrlMap: { [key: string]: string };
    rfmToWeb: boolean;
    shellAndConfigApiEndpoint: string;
    splashScreenTimeoutInMilliseconds: number;
    officeUriProtocolEnabled: boolean;
}

export interface PwaMockConfig {
    appServiceError?: boolean;
    appServiceLaunchError?: boolean;
    appsLaunched?: Array<LaunchedApp>;
    hasModernPerpetual?: boolean;
    hasOldPerpetual?: boolean;
    installedApps?: Array<string>;
    localMruMode?: string;
    noO365?: boolean;
    notLicensed?: boolean;
    protocolUnsupported?: boolean;
    urlLaunchError?: boolean;
    wrapperVersion?: WrapperVersion;
}

@Injectable({
    providedIn: 'root'
})
export class PwaConfigService {
    public readonly config: PwaConfig;

    constructor(configParserService: ConfigParserService) {
        // Initialize to default values if there was failure to read user context from API response
        this.config = configParserService.parse<PwaConfig>('pwaConfig') || {
            bridgeTimeoutInSeconds: 0,
            diagnosticsTimeoutInSeconds: 30,
            enablePwaIdleCallback: false,
            installedAppsToLookFor: null,
            oobToWeb: false,
            pwaJumpListEnabled: false,
            PwaStartPageEnabled: false,
            resourceUrlMap: null,
            rfmToWeb: false,
            shellAndConfigApiEndpoint: null,
            splashScreenTimeoutInMilliseconds: 2000,
            officeUriProtocolEnabled: false
        };

        if (this.config.mock) {
            window.appsLaunched = new Array<LaunchedApp>();
            this.config.mock.appsLaunched = window.appsLaunched;
        }
    }
}
